import { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Button } from '@intellecteu/common-ui';
import { isEmpty } from 'app/utils';
import { StepperContext, TStepperContext } from '../context';

import s from './styles.module.scss';

type NavigationProps = {
  maxSteps: number;
  currentIndex: number;
  onClickNext: () => void;
  onClickBack: () => void;
  onClickCancel: () => void;
  isLoading: boolean;
};

/** will need to be a child of a Formik component to have access to Formik context */
const Navigation = ({
  maxSteps,
  currentIndex,
  onClickNext,
  onClickBack,
  onClickCancel,
  isLoading,
}: NavigationProps) => {
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === maxSteps - 1;

  const { validateForm, handleSubmit, isValid, errors } = useFormikContext();
  const { serverErrors } = useContext<TStepperContext>(StepperContext);

  // Will run form.validateForm() when the currentIndex prop is changed
  useEffect(() => {
    const shouldValidate = isEmpty(serverErrors) || (!isEmpty(serverErrors) && isEmpty(errors));

    if (shouldValidate) {
      validateForm();
    }
  }, [currentIndex, validateForm, serverErrors]);

  return (
    <div className={s.formNavigation}>
      {!isFirstStep ? (
        <Button onClick={onClickBack} variant="secondary">
          Previous step
        </Button>
      ) : (
        <Button variant="secondary" onClick={onClickCancel}>
          Cancel
        </Button>
      )}

      {isLastStep ? (
        <Button disabled={!isValid} onClick={() => handleSubmit()} isLoading={isLoading}>
          Confirm
        </Button>
      ) : (
        <Button disabled={!isValid} onClick={onClickNext}>
          Continue
        </Button>
      )}
    </div>
  );
};

export { Navigation };
